// extracted by mini-css-extract-plugin
export default {"detailsContainer":"TypeRegionMapper_detailsContainer__L9CTo"};